export default "__VITE_ASSET__3b35873a__"